import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["part"]
const _hoisted_2 = {
  class: "position-absolute start-50 top-50",
  style: {"z-index":"2000"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "position-absolute top-0 start-0 end-0 bottom-0 bg-body",
  style: {"z-index":"1900","opacity":"0.2"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InjectStyles = _resolveComponent("InjectStyles")!
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "root",
    class: "pis-component position-relative",
    part: _ctx.componentName
  }, [
    (_ctx.isReady)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.isWebComponent)
            ? (_openBlock(), _createBlock(_component_InjectStyles, {
                key: 0,
                items: _ctx.store?.options.styles
              }, null, 8, ["items"]))
            : _createCommentVNode("", true),
          (_ctx.store?.data.isLoadingData)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_2, [
                  _renderSlot(_ctx.$slots, "loader", {}, () => [
                    _createVNode(_component_Spinner)
                  ])
                ]),
                _hoisted_3
              ], 64))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 8, _hoisted_1))
}